/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionBar from './ActionBar';
import { resetFilters } from 'store/Filters/actions';
import get from 'lodash/get';
import { TableWrapper, Wrapper } from './styled';
import Table from './Table';
import { clearError, hideVulnTemplateDetail, loadVulnTemplateDetail, resetState } from '../actions/Actions';
import { selectCreationErrorMessage, selectError, selectErrorMessage, selectShowDetail } from 'store/KnowledgeBase/selectors';
import VulnTemplateDetail from './VulnTemplateDetail';
import ErrorDialog from 'Common/Components/ErrorDialog';
import { getCustomAttributes } from 'store/CustomAttributes/actions';

const KnowledgeBaseContext = ({ params }) => {
  const showDetail = useSelector(selectShowDetail);
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  const creationErrorMessage = useSelector(selectCreationErrorMessage);

  const handleParamId = useCallback(() => {
    const id = get(params, 'id', 0);
    if (parseInt(id, 10) > 0) dispatch(loadVulnTemplateDetail(id));
    else dispatch(hideVulnTemplateDetail());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  useEffect(() => {
    handleParamId();
  }, [handleParamId]);

  useEffect(() => () => {
    dispatch(resetState());
    dispatch(resetFilters('knowledgeBase'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCustomAttributes());
  }, [dispatch]);

  return (
    <Wrapper>
      <ActionBar />
      <TableWrapper>
        <Table />
        { showDetail && <VulnTemplateDetail /> }
      </TableWrapper>
      { (error || creationErrorMessage) ? <ErrorDialog message={ creationErrorMessage || errorMessage } resetError={ () => dispatch(clearError()) } wrapperTestId="kb-confirm-dialog" okButtonTestId="kb-confirm-ok" /> : null }
    </Wrapper>
  );
};

export default KnowledgeBaseContext;
